import React from 'react';
import { actions as flowActions, getAppliedDiscount, getProductPaymentAmount, isQuotePriceDisplayable } from '../ducks';

import { Translate } from 'react-localize-redux-dep-updated';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IconCross, IconPhone, QuotePriceDisplay } from '../../../brenger-shared-ui';
import { RootState } from '../../../types';
import { getActiveLanguageSettings } from '../../../utils/localization';
import { priceAsString } from '../../../utils/price';
import { DiscountBanner } from '../components/DiscountBanner';
import { DiscountSummary } from '../components/DiscountSummary';
import TransportRequestSummary from './TransportRequestSummary';
import { getIsExcludingVat } from '../../User/ducks';

type ReduxProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const SidebarLayout: React.FC<ReduxProps> = props => {
  const exclVat = props.exclVat;
  const langSettings = getActiveLanguageSettings();
  const isBlocked = props.quote?.blocked?.result;
  // A blocked quote has no price to break down, so there is no discount to show either
  const discount = isBlocked ? null : props.discount;
  return (
    <div className="text-base">
      <div className={'sheet-layout--sidebar-shade-toggle'} onClick={props.toggleSheet} />
      <div className={'sheet-layout--sidebar-background'}>
        <div className={'summary'}>
          <div className={'summary--close'} onClick={props.toggleSheet}>
            <IconCross />
          </div>
          <div className="summary--body">
            <DiscountBanner />
            <h5 className={'text-primary'}>
              <Translate id={'request_flow.headers.transport_request_title'} />
            </h5>
            <TransportRequestSummary />
          </div>

          {props.isQuotePriceDisplayable && (
            <div className={'summary--price hidden md:block'}>
              {discount && <DiscountSummary discount={discount} />}
              <div
                className={
                  'adds-price flex items-center justify-between pt-2 mt-2 border-t-2 border-primary text-primary'
                }
              >
                <div className={'whitespace-nowrap'}>
                  <Translate id={discount ? 'request_flow.price.total_after_discount' : 'request_flow.price.total'} />
                  {exclVat && (
                    <small className={'ml-[0.3em] inline-block'}>
                      <Translate id={'request_flow.price.ex_vat'} />
                    </small>
                  )}
                </div>
                <QuotePriceDisplay addOriginalPrice={false} />
              </div>
            </div>
          )}

          {props.productPaymentAmount && (
            <div className={'pt-[1em]'}>
              <div className={'font-bold'}>
                <Translate id={'request_flow.summary.excluded'} />
              </div>
              <div className={'summary-line'}>
                <div>
                  <Translate id={'request_flow.summary.product_payment'} />
                </div>
                <div className={'adds-price'}>
                  {priceAsString({ price: { amount: props.productPaymentAmount }, addPlusMinusIndicator: false })}
                </div>
              </div>
            </div>
          )}
        </div>
        {['de-DE'].includes(langSettings.labels.full) && (
          <div className="sheet-layout--sidebar-contact">
            <Translate
              id={'request_flow.contact_us_by_phone'}
              data={{
                phone: (
                  <div style={{ display: 'inline-block' }}>
                    <IconPhone />
                    {langSettings.contact.phone.customer}
                  </div>
                ),
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: RootState) => ({
  quote: state.generalTransport.quote,
  discount: getAppliedDiscount(state),
  isQuotePriceDisplayable: isQuotePriceDisplayable(state),
  productPaymentAmount: getProductPaymentAmount(state),
  exclVat: getIsExcludingVat(state),
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: Dispatch) => ({
  toggleSheet: () => dispatch(flowActions.toggleSheet()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarLayout);
